import React from "react";
import AppRoutes from "../routes";
import HomePage from "../pages/sneakerguys/pages/home_page";
const SneakerGuysTemplate = () => {
  return (
    <>
      <div className="bg-[#F0F4FE] min-h-screen overflow-hidden">
        <AppRoutes homePage={HomePage} />
      </div>
    </>
  );
};

export default SneakerGuysTemplate;
